/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ResourceGroupEmployeesQueryVariables = Types.Exact<{
  clientApplicationId: Types.Scalars['ID']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  name_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  activityDateGte?: Types.InputMaybe<Types.Scalars['Date']['input']>;
  activityDateLte?: Types.InputMaybe<Types.Scalars['Date']['input']>;
}>;


export type ResourceGroupEmployeesQuery = { __typename: 'Query', resourceGroupEmployees?: { __typename: 'ResourceGroupEmployeeTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ResourceGroupEmployeeTypeEdge', node?: { __typename: 'ResourceGroupEmployeeType', id: string, name: string, email: string, externalId?: string | null, createdAt: string, updatedAt: string } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const ResourceGroupEmployeesDocument = new TypedDocumentString(`
    query ResourceGroupEmployees($clientApplicationId: ID!, $first: Int, $offset: Int, $orderBy: String, $name_Icontains: String, $activityDateGte: Date, $activityDateLte: Date) {
  resourceGroupEmployees(
    clientApplicationId: $clientApplicationId
    first: $first
    offset: $offset
    orderBy: $orderBy
    name_Icontains: $name_Icontains
    activityDateGte: $activityDateGte
    activityDateLte: $activityDateLte
  ) {
    edges {
      node {
        id
        name
        email
        externalId
        createdAt
        updatedAt
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `);

export const useResourceGroupEmployeesQuery = <
      TData = ResourceGroupEmployeesQuery,
      TError = unknown
    >(
      variables: ResourceGroupEmployeesQueryVariables,
      options?: Omit<UseQueryOptions<ResourceGroupEmployeesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ResourceGroupEmployeesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ResourceGroupEmployeesQuery, TError, TData>(
      {
    queryKey: ['ResourceGroupEmployees', variables],
    queryFn: fetcher<ResourceGroupEmployeesQuery, ResourceGroupEmployeesQueryVariables>(ResourceGroupEmployeesDocument, variables),
    ...options
  }
    )};

useResourceGroupEmployeesQuery.getKey = (variables: ResourceGroupEmployeesQueryVariables) => ['ResourceGroupEmployees', variables];

export const useInfiniteResourceGroupEmployeesQuery = <
      TData = InfiniteData<ResourceGroupEmployeesQuery>,
      TError = unknown
    >(
      variables: ResourceGroupEmployeesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ResourceGroupEmployeesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ResourceGroupEmployeesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ResourceGroupEmployeesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ResourceGroupEmployees.infinite', variables],
      queryFn: (metaData) => fetcher<ResourceGroupEmployeesQuery, ResourceGroupEmployeesQueryVariables>(ResourceGroupEmployeesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteResourceGroupEmployeesQuery.getKey = (variables: ResourceGroupEmployeesQueryVariables) => ['ResourceGroupEmployees.infinite', variables];


useResourceGroupEmployeesQuery.fetcher = (variables: ResourceGroupEmployeesQueryVariables) => fetcher<ResourceGroupEmployeesQuery, ResourceGroupEmployeesQueryVariables>(ResourceGroupEmployeesDocument, variables);
